import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { environment, Role, RoleService } from '@perval/shared';
import { featureFlipping } from '../core/feature-flipping';
import { DrawerItemComponent } from './drawer-item/drawer-item.component';
import { MenuItem } from './menu-link';

@Component({
  selector: 'admin-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    DrawerItemComponent,
  ],
  templateUrl: './admin.layout.html',
  styleUrls: ['./admin.layout.scss'],
})
export class AdminLayout implements OnInit {
  @ViewChild('sidenav') sidenav!: MatSidenav;

  isExpanded = true;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;

  menuItems: MenuItem[] = [];

  constructor(private readonly roleService: RoleService) {}

  ngOnInit() {
    const currentUserRoles = this.roleService.currentUserRoles;
    this.menuItems = [
      {
        title: 'Gestion des clients',
        link: 'admin/manage-clients',
        icon: 'people',
        isActiveFeature: featureFlipping.manage_clients,
        isAuthorized: false,
      },
      {
        title: 'Gestion des utilisateurs X.NOT',
        link: 'admin/manage-users',
        icon: 'people',
        isActiveFeature: featureFlipping.manage_users,
        isAuthorized: currentUserRoles.includes(Role.ADMIN_XNOTACCOUNT_CREATE),
      },
      {
        title: 'Suivi de consommation',
        link: 'admin/consumption-tracking',
        icon: 'trending_up',
        isActiveFeature: featureFlipping.consumption_tracking,
        isAuthorized: currentUserRoles.includes(
          Role.ADMIN_CONSUMPTIONTRACKING_EXPORT,
        ),
      },
      {
        title: "Gestion de l'API",
        link: 'admin/manage-api',
        icon: 'settings',
        isActiveFeature: featureFlipping.manage_api,
        isAuthorized: false,
      },
    ];
  }

  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }

  redirectHome() {
    window.location.href = `${environment.host}/content/accueil`;
  }
}
